import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const GetActiveExpenseCategories = async (): Promise<
  ApiResponse<any>
> => {
  try {
    const response = await axiosClientv1.get(`/expense-categories/active`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load expense categories.",
      categories: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetExpenseCategories = async (params: {
  page: number;
  limit: number;
  search?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/expense-categories`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load expense categories.",
      data: { data: [], total: 0 },
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const CreateExpenseCategory = async (payload: {
  name: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(
      `/expense-categories/create`,
      payload,
    );
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to create category.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const UpdateExpenseCategory = async (payload: {
  id: string;
  name: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(
      `/expense-categories/update`,
      payload,
    );
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to update category.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const DeleteExpenseCategory = async (
  id: string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/expense-categories/delete`, {
      id,
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete category.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

// Subcategory Services
export const GetActiveExpenseSubcategories = async (): Promise<
  ApiResponse<any>
> => {
  try {
    const response = await axiosClientv1.get(`/expense-subcategories/active`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load subcategories.",
      subcategories: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetExpenseSubcategories = async (params: {
  page: number;
  limit: number;
  search?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/expense-subcategories`, {
      params,
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load subcategories.",
      data: { data: [], total: 0 },
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const CreateExpenseSubcategory = async (payload: {
  category_id: string;
  name: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(
      `/expense-subcategories/create`,
      payload,
    );
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to create subcategory.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const UpdateExpenseSubcategory = async (payload: {
  id: string;
  category_id: string;
  name: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(
      `/expense-subcategories/update`,
      payload,
    );
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to update subcategory.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const DeleteExpenseSubcategory = async (
  id: string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/expense-subcategories/delete`, {
      id,
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to delete subcategory.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const CreateExpense = async (
  payload: FormData | any,
): Promise<ApiResponse<any>> => {
  try {
    const isFormData = payload instanceof FormData;
    const response = await axiosClientv1.post(`/expenses/create`, payload, {
      headers: isFormData
        ? { "Content-Type": "multipart/form-data" }
        : undefined,
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to record expense.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const GetExpenses = async (params: {
  page: number;
  limit: number;
  search?: string;
  category_id?: string | null;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/expenses`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load expenses.",
      data: { data: [], total: 0 },
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};
